import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";

type Props = {
  viewOnly: boolean;
  editMode: boolean;
  checkIfRecordBeingBusy?: (record: any) => boolean;
  updateRecord?: (data: any, record: any) => void;
  handlePersonImageClick?: (record: any) => void;
};

export const useSeasonRosterColumns = ({
  viewOnly,
  editMode,
  checkIfRecordBeingBusy,
  updateRecord,
  handlePersonImageClick,
}: Props) => {
  const {
    createRosterNumberColumn,
    createRosterNameColumn,
    createPersonDobColumn,
    createPersonNationalityColumn,
    createPersonStatusColumn,
    createRosterPositionColumn,
    createRosterIsCaptainColumn,
  } = useSharedColumnBuilder();

  const checkIfReadonly = () => !editMode || viewOnly;
  const checkIfDisabled = (record: any) => checkIfRecordBeingBusy?.(record) ?? false;

  return [
    createRosterNumberColumn({
      readonly: checkIfReadonly,
      disabled: checkIfDisabled,
      onChange: (value, record) => {
        record.number = value;
        updateRecord?.({ number: value }, record);
      },
      withSorter: true,
    }),
    createRosterNameColumn({ withSorter: true, handlePersonImageClick }),
    createPersonDobColumn({ withSorter: true }),
    createPersonNationalityColumn(),
    createPersonStatusColumn(),
    createRosterPositionColumn({
      readonly: checkIfReadonly,
      disabled: checkIfDisabled,
      onChange: (value, record) => {
        record.position = value;
        updateRecord?.({ position: value }, record);
      },
    }),
    createRosterIsCaptainColumn({
      readonly: checkIfReadonly,
      disabled: checkIfDisabled,
      onChange: (value, record) => {
        record.isCaptain = value;
        updateRecord?.({ isCaptain: value }, record);
      },
    }),
  ];
};
